import ListItemComponent from '../../../../stories/molecules/list-items'
import { listItemListViewVariantOptions } from '../../../../stories/molecules/list-items/constants'
import {
  LoadingContainer,
  ProjectMembersTabMembersContainer
} from '../../../styled-components'
import { isEmpty } from 'lodash'
import ProjectMembersEmptyList from '../project-member-empty-list'
import { projectMembersTabOptions } from '../../../constants'
import TeamItem from './team-item'
import { iconSizeOptions } from '../../../../stories/atoms/icons/icons-sizes'
import { SpinnerGrey } from '../../../../stories/atoms/icons/special'
import PropTypes from 'prop-types'

const TeamsList = ({ teams = [], isLoading = false }) => {
  if (isLoading) {
    return (
      <LoadingContainer>
        <SpinnerGrey size={iconSizeOptions['ICON-XL']} />
      </LoadingContainer>
    )
  }

  if (isEmpty(teams)) {
    return <ProjectMembersEmptyList variant={projectMembersTabOptions.TEAMS} />
  }

  return (
    <ProjectMembersTabMembersContainer>
      <ListItemComponent.Root
        listViewType={listItemListViewVariantOptions.TOGETHER}
        dividerFull={false}
        hideDivider
        style={{
          border: 'none'
        }}
      >
        {teams.map((item) => {
          return <TeamItem key={item.id} item={item} />
        })}
      </ListItemComponent.Root>
    </ProjectMembersTabMembersContainer>
  )
}

TeamsList.propTypes = {
  teams: PropTypes.array,
  isLoading: PropTypes.bool
}

export default TeamsList
